

import React, { useState, useEffect } from 'react';
import { Button, Card, Form, Row, Col, Modal, Toast } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import { BsSearch, BsPencilSquare, BsTrash } from 'react-icons/bs';
import { CgAdd } from 'react-icons/cg';
import CatVacaciones from '../../../Services/Catalogos/CatVacaciones';
import DTOVacaciones from './DTO/DTOVacaciones';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { MsgInformativo } from '../../../Utils/Toast/msgInformativo';
import DTOInsertVacaciones from './DTO/DTOInsertVacaciones';
import DTOEmpleadoInfo from './DTO/DTOEmpleadoInfo';
import { Sort } from '@mui/icons-material';
import CatEmpleados from '../../../Services/Catalogos/CatEmpleados';





const VacacionesComponent: React.FC = () => {
    const [vacaciones, setVacaciones] = useState<DTOVacaciones[]>([]);
    const [Data, setData] = useState<DTOVacaciones[]>([]);
    const [showModal, setShowModal] = useState<boolean>(false);
    const [editando, setEditando] = useState<boolean>(false);
    const [currentVacacion, setCurrentVacacion] = useState<Partial<DTOVacaciones>>({});
    const [filtro, setFiltro] = useState<string>('');
    const [Inicio, setInicio] = useState<string>(currentDate());
    const [Fin, setFin] = useState<string>(currentDate());
    const [selectedDays, setSelectedDays] = useState<Date[]>([]);
    const [vacacionesDetalle, setVacacionesDetalle] = useState<DTOVacaciones[]>([]);
    const [fechaLimite, setFechaLimite] = useState<Date | null>(null);
    const [show, setShowMsg] = useState(false)
    const [msg, setMsg] = useState('')
    const [header, setHeader] = useState('')
    const msgColor = 'primary'
    const [showConfirmModal, setShowConfirmModal] = useState<boolean>(false);
    const [confirmData, setConfirmData] = useState<Partial<DTOInsertVacaciones>>({});
    const [showInitialModal, setShowInitialModal] = useState<boolean>(true); // Por defecto visible
    const [empleadoInfo, setEmpleadoInfo] = useState<DTOEmpleadoInfo | null>(null); // Estado para la información del empleado
    const [isFotoFirmaValid, setIsFotoFirmaValid] = useState<boolean>(false);
    const [specialObservaciones, setSpecialObservaciones] = useState('');
        const [reloadKey, setReloadKey] = useState(0);



    const [showDetalleModal, setShowDetalleModal] = useState(false);
const [detalleFechas, setDetalleFechas] = useState<{ tipo: string; datos: string[] }>({
    tipo: '',
    datos: [],
});
const [showSpecialModal, setShowSpecialModal] = useState(false); // Estado para el nuevo modal
const [specialDaysToPay, setSpecialDaysToPay] = useState<number | null>(null); // Días a pagar en solicitud especial

const [showSpecialConfirmModal, setShowSpecialConfirmModal] = useState(false);
const [specialConfirmData, setSpecialConfirmData] = useState({
    numEmpleado: '',
    diasPagar: 0,
    
});



const [detalleTexto, setDetalleTexto] = useState("");
const [showDetalle, setShowDetalle] = useState(false);
const [showDiaPagoCalendar, setShowDiaPagoCalendar] = useState<boolean>(false);


// Función para mostrar el detalle
const mostrarDetalle = (texto: string) => {
  setDetalleTexto(texto || "Sin información");
  setShowDetalle(true);
};


const handleDoubleClickFechas = (tipo: string, datosOriginales: any, fechas: string[]) => {
    // Limpiar datos: quitar valores vacíos o "Sin datos"
    const datosLimpios = fechas.filter(fecha => fecha && fecha !== 'Sin datos').map(fecha => formatDate(fecha));

    setDetalleFechas({
        tipo,
        datos: datosLimpios, // Pasamos solo las fechas válidas
    });

    setShowDetalleModal(true); // Mostramos el modal
};


const validarFotoFirma = async (): Promise<void> => {
    const numEmpleado = localStorage.getItem('numEmpleado')?.replace(/"/g, '');
    
    if (!numEmpleado) {
        console.error('No se encontró el número de empleado en localStorage');
        return;
    }

    try {
        // Verificar si la foto y firma están registradas
        const fotoUrl = await CatEmpleados.GetFotoFirma(numEmpleado, 'foto');
        const firmaUrl = await CatEmpleados.GetFotoFirma(numEmpleado, 'firma');
        
        // Si ambos están disponibles, habilitar los botones
        if (fotoUrl && firmaUrl) {
            setIsFotoFirmaValid(true);  
        } else {
            setIsFotoFirmaValid(false); 
        }
    } catch (error) {
        console.error('Error al validar foto o firma:', error);
        setIsFotoFirmaValid(false); // Bloquear si ocurre un error en la validación
    }
};


useEffect(() => {
    validarFotoFirma(); // Llamar a la validación al cargar el componente
}, []);

      
useEffect(() => {
    const numEmpleado = localStorage.getItem('numEmpleado')?.replace(/"/g, '');
    if (numEmpleado) {
        CatVacaciones.getAllVacacionesInfo(numEmpleado)
            .then((response) => {
                if (response.data && response.data.length > 0) {
                    setEmpleadoInfo(response.data[0]); // Toma el primer elemento
                    setShowInitialModal(true);
                } else {
                    console.error('No se encontró información del empleado.');
                }
            })
            .catch((error) => {
                console.error('Error al obtener información del empleado:', error);
            });
    }
}, []);


    useEffect(() => {
        cargarVacaciones();
    }, []);

    useEffect(() => {
        calcularDiasTomar();
    }, [Inicio, Fin]);
    
   
    useEffect(() => {
        setCurrentVacacion((prevState) => ({
            ...prevState,
            diasTomar: selectedDays.length, // Total de días seleccionados
        }));
    }, [selectedDays]);
    

    
    

    const mostrarConfirmacion = (): void => {
        setConfirmData({
            tipoSolicitud: currentVacacion.tipoSolicitud,
            fechaInicio: Inicio,
            fechaFin: Fin,
            diasSolicitados: currentVacacion.diasTomar || selectedDays.length,
            diasSalteados: selectedDays.map((day) => day.toLocaleDateString()),
            diasPagar: currentVacacion.diasPagar || 0 , 
            diaPago: currentVacacion.diaPago || null,
            observaciones: currentVacacion.observaciones
        });
        setShowConfirmModal(true); // Muestra el modal de confirmación
    };
    
    
    function currentDate ():  string {
        var today = new Date()
        var dd = String(today.getDate()).padEnd(2,'0')
        var mm = String(today.getMonth() + 1  ).padStart(2, '0')
        var yyyy = today.getFullYear()
        return yyyy+'-' + mm + '-'  + dd
    }


   
    
    

    const cargarVacaciones = (): void => {
        const numEmpleado = localStorage.getItem('numEmpleado');
        if (!numEmpleado) {
            console.error('No se encontró el NumEmpleado en localStorage');
            return;
        }
        const cleanedNumEmpleado = numEmpleado.replace(/"/g, '');

        
        CatVacaciones.GetAllVacaciones(cleanedNumEmpleado)
  .then((response) => {
    setVacaciones([...response.data]); // <- ⚠️ Fuerza nueva referencia
    setData([...response.data]);       // <- también aquí si aplica
    setReloadKey(prev => prev + 1);    // <- ⚡ Forzar rerender visual
  })
  

            .catch((error) => console.error('Error al cargar vacaciones:', error));

        CatVacaciones.GetAllVacacionesDetalle(cleanedNumEmpleado)
            .then((response) => setVacacionesDetalle(response.data))
            .catch((error) => console.error('Error al cargar detalles:', error));
    };
    

    const filtraReporte = (e: React.ChangeEvent<HTMLInputElement>): void => {
        const value = e.target.value.toLowerCase();
        setFiltro(value);
        const filtered = Data.filter(
            (item) =>
                String(item.numEmpleado).toLowerCase().includes(value) ||
                String(item.tipoSolicitud).toLowerCase().includes(value)
        );
        setData(filtered);
    };




    const handleSpecialRequest = (): void => {
        if (specialDaysToPay === null || specialDaysToPay <= 0) {
            setHeader('Error');
            setMsg('Debe ingresar un número válido de días a pagar.');
            setShowMsg(true);
            return;
        }
    
        // Guardar datos en el estado temporal
        setSpecialConfirmData({
            numEmpleado: currentVacacion.numEmpleado ?? '',
            diasPagar: specialDaysToPay || 0,
           
        });
    
        // Mostrar el modal de confirmación
        setShowSpecialConfirmModal(true);
    };
    
    
    


    const abrirModal = (vacacion?: DTOVacaciones): void => {
        const numEmpleado = localStorage.getItem('numEmpleado')?.replace(/"/g, '');
        if (!numEmpleado) {
            console.error('No se encontró el NumEmpleado en localStorage');
            return;
        }
    
        if (vacacion) {
            // Editar una vacación existente
            setEditando(true);
            setCurrentVacacion({ ...vacacion, numEmpleado });
            setInicio(vacacion.fechaInicio || ''); // Asigna la fecha existente
            setFin(vacacion.fechaFin || '');       // Asigna la fecha existente
        } else {
            // Nueva vacación
            setEditando(false);
            setCurrentVacacion({ 
                numEmpleado, 
                tipoSolicitud: '0', 
                diasTomar: 0, 
                diasPagar: 0, 
                diasSalteados: [], 
                fechaInicio: '', 
                fechaFin: '', 
                observaciones: ''
            });
            setInicio(''); // Limpiar Fecha Inicio
            setFin('');    // Limpiar Fecha Fin
            setSelectedDays([]); // Limpiar los días seleccionados
            
        }
    
        setShowModal(true); // Mostrar el modal
    };
    
    
    
    

  

    const cerrarModal = (): void => {
        setCurrentVacacion({}); 
        setInicio(''); 
        setFin('');    
        setSelectedDays([]); 
        setShowModal(false); 
        
    };
    
    const getColorPorEstado = (estado: string) => {
  const colores = new Map<string, string>([
    ['Aceptado', '#d4edda'],      // Verde claro
    ['Rechazado', '#f8d7da'],     // Rojo claro
    ['Pendiente', '#ffcc99'],     // Naranja claro
    ['Anticipada', '#fff3cd'],    // Amarillo claro
    ['Sin solicitudes', 'white'], // Por si acaso
  ]);
  return colores.get(estado) || 'white';
};


    
    const guardarVacacion = async (): Promise<void> => {
        if (!currentVacacion.tipoSolicitud) {
            setHeader('Error');
            setMsg('Debes seleccionar el tipo de solicitud.');
            setShowMsg(true);
            return;
        }
    
        // Validar fechas para tipo "Rango"
        if (currentVacacion.tipoSolicitud === 'Rango') {
            const fechaInicio = new Date(`${Inicio}T00:00:00`);
            const fechaFin = new Date(`${Fin}T00:00:00`);
            const fechaLimite = new Date();
            fechaLimite.setMonth(new Date().getMonth() + 1);
            fechaLimite.setDate(fechaLimite.getDate() + 7); // Un mes + una semana desde hoy
    
            if (fechaInicio > fechaLimite || fechaFin > fechaLimite) {
                setHeader('Error');
                setMsg(`Las fechas no pueden exceder un mes y una semana desde hoy (${fechaLimite.toLocaleDateString()}).`);
                setShowMsg(true);
                return;
            }
    
            if (fechaFin < fechaInicio) {
                setHeader('Error');
                setMsg(`La Fecha Fin no puede ser anterior a la Fecha Inicio (${Inicio}).`);
                setShowMsg(true);
                return;
            }
        }
    
        // Validar días salteados
        if (currentVacacion.tipoSolicitud === 'VacacionesPorDisfrutar') {
            const oneMonthAndWeekLater = new Date();
            oneMonthAndWeekLater.setMonth(new Date().getMonth() + 2);
            oneMonthAndWeekLater.setDate(oneMonthAndWeekLater.getDate() + 7);
    
            if (selectedDays.some((day) => day > oneMonthAndWeekLater)) {
                setHeader('Error');
                setMsg(`No puedes seleccionar días mayores a un mes y una semana desde hoy (${oneMonthAndWeekLater.toLocaleDateString()}).`);
                setShowMsg(true);
                return;
            }
        }
    
        // Preparar el DTO para insertar la vacación
        const DTOInsertVacaciones = {
            numEmpleado: currentVacacion.numEmpleado ?? '',
            tipoSolicitud: currentVacacion.tipoSolicitud ?? '',
            fechaInicio: Inicio ?? '',
            fechaFin: Fin ?? '',
            diasSolicitados: currentVacacion.diasTomar || selectedDays.length,
            diasPagar: currentVacacion.diasPagar || 0,
            diasSalteados: selectedDays.map((day) => day.toISOString().split('T')[0]),
            observaciones: currentVacacion.observaciones ?? '', 
            estado: 'Pendiente', // Estado por defecto
            diaPago: currentVacacion.diaPago || null,
        };
    
        try {
            // Insertar la vacación
            const response = await CatVacaciones.PostInsertVacaciones(DTOInsertVacaciones);
            if (response.status === 200) {
                console.log('Vacación guardada correctamente:', DTOInsertVacaciones);
    
                setHeader('Informativo');
                setMsg('La solicitud se ha guardado correctamente.');
                setShowMsg(true);
                cerrarModal();
                cargarVacaciones();
                setReloadKey(prev => prev + 1); 
    
                // Extraer datos para la notificación
                const correoSupervisor = localStorage.getItem('correoSupervisor')?.replace(/"/g, '');
                const numEmpleado = currentVacacion.numEmpleado ?? localStorage.getItem('numEmpleado')?.replace(/"/g, '');

                console.log('Correo supervisor:', correoSupervisor);
                console.log('NumEmpleado:', numEmpleado);
    
                if (correoSupervisor && numEmpleado) {
                    // Buscar el empleado en los detalles, si existe
                    const empleadoDetalle = vacacionesDetalle.find(
                        (detalle) => detalle.numEmpleado === numEmpleado
                    );
    
                    // Configurar valores por defecto si no se encuentran
                    
                    // const nombre = empleadoDetalle?.nombre ?? 'Empleado desconocido';

                    const user = JSON.parse(localStorage.getItem('User') || '{}');
                    const nombre = user ?? 'Empleado desconocido'; // Asignamos el nombre del usuario o uno por defecto
                
                    const estado = empleadoDetalle?.estado ?? 'Pendiente';

    
                    // Llamar al servicio de notificación
                    await CatVacaciones.enviarNotificacionVacaciones(
                        numEmpleado,
                        nombre,
                        correoSupervisor,
                        estado,
                        'La solicitud ha sido registrada y está pendiente de aprobación.'
                    );
                    console.log('Notificación enviada correctamente');
                    setHeader('Notificación');
                    setMsg('Se ha enviado una notificación al supervisor.');
                    setShowMsg(true);
                } else {
                    console.error('Faltan datos clave para enviar la notificación.');
                }
            }
        } catch (error: any) {
            const errorMessage = error.response?.data?.message || 'Error al procesar la solicitud.';
            console.error('Error al guardar la vacación:', error);
            setHeader('Error');
            setMsg(errorMessage);
            setShowMsg(true);
        }
    };
    

    


    const confirmSpecialRequest = async (): Promise<void> => {
        const DTOInsertVacaciones = {
            id: 0,
            numEmpleado: specialConfirmData.numEmpleado,
            tipoSolicitud: 'SoloDiasPago',
            fechaInicio: '', // Cadena vacía para solicitudes especiales
            fechaFin: '',    // Cadena vacía para solicitudes especiales
            diasTomar: 0,
            diasPagar: specialConfirmData.diasPagar,
            diasSolicitados: 0,
            diasSalteados: [], 
            estado: 'Pendiente',
            observaciones: specialObservaciones,
            diaPago: currentVacacion.diaPago || null,

        };
    
        try {
            // Insertar la solicitud especial
            const response = await CatVacaciones.PostInsertVacaciones(DTOInsertVacaciones);
            if (response.status === 200) {
                console.log('Solicitud especial enviada correctamente:', DTOInsertVacaciones);
    
                // Mostrar mensaje de éxito
                setHeader('Informativo');
                setMsg('La solicitud especial se ha enviado correctamente.');
                setShowMsg(true);
                setShowSpecialConfirmModal(false); // Cierra el modal de confirmación
                setShowSpecialModal(false); // Cierra el modal de solicitud
                cargarVacaciones(); // Actualiza la lista de solicitudes
                setReloadKey(prev => prev + 1); // 
    
                // Enviar notificación al supervisor
                const correoSupervisor = localStorage.getItem('correoSupervisor')?.replace(/"/g, '');
                const numEmpleado = specialConfirmData.numEmpleado;
                console.log('Correo supervisor:', correoSupervisor);
                console.log('NumEmpleado:', numEmpleado);
    
                if (correoSupervisor && numEmpleado) {
                    // Datos de la solicitud especial
                    
                    const user = JSON.parse(localStorage.getItem('User') || '{}');
                    const nombre = user ?? 'Empleado desconocido'; // Asignamos el nombre del usuario o uno por defecto
                    const estado = 'Pendiente'; // Estado por defecto
    
                    // Enviar la notificación
                    await CatVacaciones.enviarNotificacionVacaciones(
                        numEmpleado,
                        nombre,
                        correoSupervisor,
                        estado,
                        `El empleado ${numEmpleado} ha solicitado el pago de ${specialConfirmData.diasPagar} días de vacaciones.`
                    );
    
                    console.log('Notificación enviada correctamente al supervisor');
                    setHeader('Notificación');
                    setMsg('Se ha enviado una notificación al supervisor.');
                    setShowMsg(true);
                } else {
                    console.error('Faltan datos clave para enviar la notificación.');
                }
            }
        } catch (error: any) {
            // Manejo de errores
            const errorMessage = error.response?.data?.message || 'Error al procesar la solicitud.';
            console.error('Error al enviar la solicitud especial:', error);
            setHeader('Error');
            setMsg(errorMessage);
            setShowMsg(true);
        }
    };
    
    

    
    const handleDayClick = (day: Date): void => {
        const today = new Date(); // Fecha actual
    
        // 1 semana después de hoy
        const oneWeekLater = new Date();
        oneWeekLater.setDate(today.getDate() + 7);
    
        // 1 mes y 1 semana después de hoy
        const oneMonthAndWeekLater = new Date();
        oneMonthAndWeekLater.setMonth(today.getMonth() + 2); // Un mes después
        oneMonthAndWeekLater.setDate(oneMonthAndWeekLater.getDate() + 7); // Agregar 7 días


        if (day.getDay() === 0) { // 0 representa el domingo
            setHeader('Error');
            setMsg(`No puedes seleccionar domingos. Por favor, elige otro día.`);
            setShowMsg(true);
            return;
        }
    
        // Validar que el día seleccionado sea al menos una semana después de hoy
        if (day < oneWeekLater) {
            setHeader('Error');
            setMsg(`Solo puedes seleccionar días a partir del ${oneWeekLater.toLocaleDateString()} (una semana después de hoy).`);
            setShowMsg(true);
            return;
        }
    
        // Validar que el día seleccionado no sea mayor a un mes y una semana desde hoy
        if (day > oneMonthAndWeekLater) {
            setHeader('Error');
            setMsg(`No puedes seleccionar días después del ${oneMonthAndWeekLater.toLocaleDateString()} (máximo permitido: 2 Meses).`);
            setShowMsg(true);
            return;
        }
    
        // Manejar selección o deselección del día
        if (selectedDays.some((d) => d.getTime() === day.getTime())) {
            setSelectedDays(selectedDays.filter((d) => d.getTime() !== day.getTime())); // Elimina el día si ya estaba seleccionado
        } else {
            setSelectedDays([...selectedDays, day]); // Agrega el día si no estaba seleccionado
        }
    };
    
    

    const calcularDiasTomar = (): void => {
        if (Inicio && Fin) {
            const fechaInicio = new Date(`${Inicio}T00:00:00`);
            const fechaFin = new Date(`${Fin}T00:00:00`);
    
            if (fechaFin >= fechaInicio) {
                const diferenciaMilisegundos = fechaFin.getTime() - fechaInicio.getTime();
                const dias = Math.round(diferenciaMilisegundos / (1000 * 60 * 60 * 24)) + 1; // +1 para incluir inicio y fin
    
                setCurrentVacacion((prevState) => ({
                    ...prevState,
                    diasTomar: dias,
                }));
            } else {
                setCurrentVacacion((prevState) => ({
                    ...prevState,
                    diasTomar: 0,
                }));
            }
        }
    };
    
   
    

   
    
    const handleFechaInicioChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
        const nuevaFechaInicio = e.target.value;
        const fechaInicio = new Date(nuevaFechaInicio);
    
        const fechaActual = new Date();
    
        // 1 semana después de hoy
        const fechaRestriccion = new Date();
        fechaRestriccion.setDate(fechaActual.getDate() + 7);
    
        // 1 mes y 1 semana desde hoy
        const fechaLimite = new Date();
        fechaLimite.setMonth(fechaActual.getMonth() + 1);
        fechaLimite.setDate(fechaLimite.getDate() + 7); // Agrega 7 días adicionales
    
        // Validar que la fecha de inicio sea al menos una semana después de hoy
        if (fechaInicio < fechaRestriccion) {
            const fechaValida = fechaRestriccion.toISOString().split('T')[0];
            setHeader('Error');
            setMsg(`Debes seleccionar una fecha de inicio mayor a: ${fechaValida}`);
            setShowMsg(true);
            return;
        }
    
        // Validar que la fecha de inicio no sea mayor a un mes y una semana desde hoy
        if (fechaInicio > fechaLimite) {
            const fechaValida = fechaLimite.toISOString().split('T')[0];
            setHeader('Error');
            setMsg(`La fecha de inicio no puede ser mayor a un mes y una  semana desde hoy (${fechaValida}).`);
            setShowMsg(true);
            return;
        }
    
        setInicio(nuevaFechaInicio); // Actualiza la fecha si pasa las validaciones
    };
    
    
    
    const handleFechaFinChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
        const nuevaFechaFin = e.target.value;
        const fechaFin = new Date(`${nuevaFechaFin}T00:00:00`);
        const fechaInicio = new Date(`${Inicio}T00:00:00`);
    
        if (!Inicio) {
            setHeader('Error');
            setMsg(`Selecciona la fecha de Inicio primero.`);
            setShowMsg(true);
            return;
        }
    
        // Calcular la fecha límite (1 mes + 1 semana desde la Fecha Inicio)
        const fechaLimite = new Date(fechaInicio);
        fechaLimite.setMonth(fechaInicio.getMonth() + 1); // Un mes después de la fecha de inicio
        fechaLimite.setDate(fechaLimite.getDate() + 7);   // Agregar 7 días adicionales
    
        // Validar que la Fecha Fin esté dentro del rango permitido
        if (fechaFin > fechaLimite) {
            setHeader('Error');
            setMsg(`La Fecha Fin no puede superar un mes y una semana desde hoy (${fechaLimite.toLocaleDateString()}).`);
            setShowMsg(true);
            setFin('');
            return;
        }
    
        // Validar que la Fecha Fin no sea anterior a la Fecha Inicio
        if (fechaFin < fechaInicio) {
            setHeader('Error');
            setMsg(`La Fecha Fin no puede ser anterior a la Fecha Inicio (${Inicio}).`);
            setShowMsg(true);
            setFin('');
            return;
        }
    
        setFin(nuevaFechaFin); // Actualiza la fecha si pasa las validaciones
    };
    

    const formatDate = (date: string): string => {
        // Verificamos que el formato sea YYYY-MM-DD y lo convertimos
        if (date.includes('-')) {
            const [year, month, day] = date.split('-');
            return `${day}/${month}/${year}`;
        }
        // Si ya está en formato DD/MM/YYYY, devolvemos como está
        return date.trim();
    };
    
    
    
  const abrirModalSolicitudEspecial = (): void => {
    const numEmpleado = localStorage.getItem('numEmpleado')?.replace(/"/g, '') || ''; // Recupera el valor desde el localStorage
    setCurrentVacacion((prevState) => ({
        ...prevState,
        numEmpleado, // Asegura que numEmpleado esté presente
    }));
    setShowSpecialModal(true); // Muestra el modal
};


    const columnsVacaciones = [
        {
            name: 'Id',
            selector: (row: DTOVacaciones) => row.id,
            sortable: true,
            width: '100px',
        },
        {
            name: 'NumEmpleado',
            selector: (row: DTOVacaciones) => row.numEmpleado,
            sortable: true,
            width: '200px',
        },
        {
            name: 'TipoSolicitud',
            selector: (row: DTOVacaciones) => row.tipoSolicitud,
            sortable: true,
            width: '200px',
        },
        // {
        //     name: 'FechaInicio',
        //     selector: (row: DTOVacaciones) => row.fechaInicio,
        //     sortable: true,
        //     width: '100px',
        // },
        // {
        //     name: 'FechaFin',
        //     selector: (row: DTOVacaciones) => row.fechaFin,
        //     sortable: true,
        //     width: '100px',
        // },
        {
            name: 'DiasTomar',
            selector: (row: DTOVacaciones) => row.diasTomar,
            sortable: true,
            width: '110px',
        },
        {
            name: 'DiasPagar',
            selector: (row: DTOVacaciones) => row.diasPagar,
            sortable: true,
            width: '110px',
        },
      {
  name: 'Día que se Pagará',
  selector: (row: DTOVacaciones) => {
    if (!row.diaPago) return '—';

    try {
      // Detecta si viene como DateTime string tipo "11/13/2025 12:00:00 AM"
      const dateValue =
        typeof row.diaPago === 'string'
          ? new Date(row.diaPago.replace(' AM', '').replace(' PM', '')) // limpia hora
          : new Date(row.diaPago);

      // Evita Invalid Date
      if (isNaN(dateValue.getTime())) return '—';

      return dateValue.toLocaleDateString('es-MX', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      });
    } catch {
      return '—';
    }
  },
  sortable: true,
  width: '150px',
},



       


        {
            name: 'Dias Disfrutados Anteriormente',
            selector: (row: DTOVacaciones) =>
                Array.isArray(row.diasSalteados)
                    ? row.diasSalteados.join(', ')
                    : typeof row.diasSalteados === 'string'
                    ? row.diasSalteados.split(',').map(date => date.trim()).join(', ')
                    : 'Sin datos',
            sortable: true,
            width: '300px',
            cell: (row: DTOVacaciones) => {
                // Aseguramos que los datos se manejen como un array
                const diasSalteados = Array.isArray(row.diasSalteados)
                    ? row.diasSalteados
                    : typeof row.diasSalteados === 'string'
                    ? row.diasSalteados.split(',').map(date => date.trim()) // Limpiamos espacios
                    : [];
        
                // Renderizamos el componente y manejamos el doble clic
                return (
                    <div onDoubleClick={() => handleDoubleClickFechas('Días Selecionados', null, diasSalteados)}>
                        {diasSalteados.length > 0
                            ? diasSalteados.map(date => formatDate(date)).join(', ') // Formateamos las fechas
                            : 'Sin datos'}
                    </div>
                );
            },
        }, 
        
        {

            name : 'FechaSolicitud', 
            selector: (row: DTOVacaciones) => row.fechaSolicitud, 
            sortable : true, 
            width: '250px', 
        }, 

        
        { name: 'Estado',   width: '100px',    selector: (row: DTOVacaciones)  =>  row. estado, sortable: true  }, 
        // {
        //     name: 'Acciones',
        //     cell: (row: DTOVacaciones) => (
        //         <div style={{ display: 'flex', gap: '10px' }}>
        //             <BsPencilSquare
        //                 size={20}
        //                 color="blue"
        //                 onClick={() => abrirModal(row)}
        //                 style={{ cursor: 'pointer' }}
        //             />
        //             <BsTrash
        //                 size={20}
        //                 color="red"
        //                 onClick={() => eliminarVacacion(row.id)}
        //                 style={{ cursor: 'pointer' }}
        //             />
        //         </div>
        //     ),
        //     width: '120px',
        // },
        
        // { name: 'Observaciones' , selector: (row: DTOVacaciones) => row.observaciones,  sortable: true,  width: '250px' }, 
        {
            name: "ComentarioSuper",
            width: "150px",
            cell: (row: DTOVacaciones) => (
              <div onDoubleClick={() => mostrarDetalle(row.comentario)}>
                {row.comentario && row.comentario.length > 30
                  ? row.comentario.slice(0, 30) + "..."
                  : row.comentario}
              </div>
            ),
          },

          {
            name: "Mis Observaciones", 
            width: "150px",
            cell: (row: DTOVacaciones) => (
              <div onDoubleClick={() => mostrarDetalle(row.observaciones || '')}>
                {row.comentario && row.observaciones && row.observaciones.length > 30
                  ? row.observaciones.slice(0, 30) + "..."
                  : row.observaciones || ''}
              </div>
            ),
        
        }
          
    ];



   

    const columnsDetalles = [
        // {name: 'Id', selector : (row: DTOVacaciones) => row.id , sortable: true , width: '130px'    }, 
        { name: 'NumEmpleado', selector: (row: DTOVacaciones) => row.numEmpleado, sortable: true, width: '130px' },
        { name: 'Nombre', selector: (row: DTOVacaciones) => row.nombre, sortable: true, width: '200px' },
        { name: 'Años Servicio', selector: (row: DTOVacaciones) => row.anosServicio, sortable: true, width: '130px' },
        { name: 'Dias por Disfrutar', selector: (row: DTOVacaciones) => row.diasRestantes, sortable: true, width: '150px' },
        { name: 'Dias Por Pagar', selector: (row: DTOVacaciones) => row.diasPagar, sortable: true, width: '130px' },
       
        // {
        //     name: 'Fecha Inicio',
        //     selector: (row: DTOVacaciones) =>
        //         row.fechaInicio
        //             ? new Date(row.fechaInicio).toLocaleDateString('es-MX', {
        //                   day: '2-digit',
        //                   month: '2-digit',
        //                   year: 'numeric',
        //               })
        //             : 'Sin datos',
        //     sortable: true,
        //     width: '150px',
        //     cell: (row: DTOVacaciones) => (
        //         <div
        //             onDoubleClick={() =>
        //                 handleDoubleClickFechas(
        //                     'Fecha Inicio',
        //                     row.fechaInicio,
        //                     Array.isArray(row.diasSalteados) ? row.diasSalteados : []
        //                 )
        //             }
        //         >
        //             {row.fechaInicio
        //                 ? new Date(row.fechaInicio).toLocaleDateString('es-MX', {
        //                       day: '2-digit',
        //                       month: '2-digit',
        //                       year: 'numeric',
        //                   })
        //                 : 'Sin datos'}
        //         </div>
        //     ),
        // },
        // {
        //     name: 'Fecha Fin',
        //     selector: (row: DTOVacaciones) =>
        //         row.fechaFin
        //             ? new Date(row.fechaFin).toLocaleDateString('es-MX', {
        //                   day: '2-digit',
        //                   month: '2-digit',
        //                   year: 'numeric',
        //               })
        //             : 'Sin datos',
        //     sortable: true,
        //     width: '150px',
        //     cell: (row: DTOVacaciones) => (
        //         <div
        //             onDoubleClick={() =>
        //                 handleDoubleClickFechas(
        //                     'Fecha Fin',
        //                     row.fechaFin,
        //                     Array.isArray(row.diasSalteados) ? row.diasSalteados : []
        //                 )
        //             }
        //         >
        //             {row.fechaFin
        //                 ? new Date(row.fechaFin).toLocaleDateString('es-MX', {
        //                       day: '2-digit',
        //                       month: '2-digit',
        //                       year: 'numeric',
        //                   })
        //                 : 'Sin datos'}
        //         </div>
        //     ),
        // },
        
        // {
        //     name: 'Dias Selecionados',
        //     selector: (row: DTOVacaciones) =>
        //         Array.isArray(row.diasSalteados)
        //             ? row.diasSalteados.join(', ')
        //             : typeof row.diasSalteados === 'string'
        //             ? row.diasSalteados
        //             : 'Sin datos',
        //     sortable: true,
        //     width: '300px',
        //     cell: (row: DTOVacaciones) => {
        //         const diasSalteados = Array.isArray(row.diasSalteados)
        //             ? row.diasSalteados
        //             : typeof row.diasSalteados === 'string'
        //             ? row.diasSalteados.split(',')
        //             : [];
        //         return (
        //             <div onDoubleClick={() => handleDoubleClickFechas('Días Selecionados', null, diasSalteados)}>
        //                 {diasSalteados.length > 0 ? diasSalteados.join(', ') : 'Sin datos'}
        //             </div>
        //         );
        //     },
        // },
        
        
        
    ];
    
    useEffect(() => {
        if (!currentVacacion.tipoSolicitud || currentVacacion.tipoSolicitud !== "VacacionesPorDisfrutar") {
            setCurrentVacacion((prevState) => ({
                ...prevState,
                tipoSolicitud: "VacacionesPorDisfrutar", // Forza el tipo de solicitud a "Días Salteados"
            }));
        }
    }, [currentVacacion, setCurrentVacacion]);
    

    
    
    return (
        

        <div>
            <Card>
                <Card.Body>
                    <Row className="mb-3">
                        {/* <Col>
                            <Form.Control
                                type="text"
                                placeholder="Filtrar..."
                                value={filtro}
                                onChange={filtraReporte}
                            />
                        </Col> */}
                        {/* <Col xs="auto">
                            <Button variant="primary" onClick={cargarVacaciones}>
                                <BsSearch /> Buscar
                            </Button>
                        </Col> */}
                        <Col xs="auto">
                            <Button variant="success" onClick={() => abrirModal()} disabled={!isFotoFirmaValid}>
                                <CgAdd /> Solicitar Vacaciones 
                            </Button>
                        </Col>

                                                {/* <Col xs="auto">
                            <Button variant="warning" onClick={() => setShowSpecialModal(true)}>
                                Solicitud Especial
                            </Button>
                        </Col> */}



                          <Col xs="auto">
                        <Button variant="warning" onClick={abrirModalSolicitudEspecial} disabled={!isFotoFirmaValid}> <CgAdd />
                        Solo Dias Pagar
                    </Button> 
                    </Col>
                    {!isFotoFirmaValid && (
    <Toast>
        <Toast.Body>
            Para poder solicitar vacaciones o días a pagar, debes tener una foto y firma registrada.
        </Toast.Body>
    </Toast>
)}


                        
                    </Row>
                    <Row className="mt-4">
                   
                    {/* <Col md={6}>
                        <Card>
                            <Card.Header className="bg-primary text-white">Solicitudes de Vacaciones</Card.Header>
                            <Card.Body>
                                <DataTable
                                    columns={columnsVacaciones}
                                    data={vacaciones} 
                                    pagination
                                    highlightOnHover
                                    
                                />
                            </Card.Body>
                        </Card>
                    </Col> */}

                    {/* Tabla 2: Detalles */}
                    {/* <Col md={8}>
                        <Card>
                            <Card.Header className="bg-success text-white">Detalles de las Solicitudes</Card.Header>
                            <Card.Body>
                                <DataTable
                                    columns={columnsDetalles}
                                    data={vacacionesDetalle}  
                                    pagination
                                    highlightOnHover
                                />
                            </Card.Body>
                        </Card>
                    </Col> */}
                </Row>


                
                <Row className="d-flex flex-column align-items-center mt-4">
    {/* Tabla 1: Solicitudes */}
    <Col md={10} className="mb-4">
        <Card>
            <Card.Header className="bg-primary text-white text-center">
                Solicitudes de Vacaciones
            </Card.Header>
            <Card.Body>
                {/* <DataTable
                    columns={columnsVacaciones}
                    data={vacaciones}
                    pagination
                    highlightOnHover
                /> */}

               <DataTable
  key={reloadKey}
  columns={columnsVacaciones}
  data={vacaciones}
  pagination
  highlightOnHover
  conditionalRowStyles={[
    {
      when: (row: DTOVacaciones) => true,
      style: (row: DTOVacaciones) => ({
        backgroundColor: getColorPorEstado(row.estado),
      }),
    },
  ]}
/>



            </Card.Body>
        </Card>
    </Col>

    {/* Tabla 2: Detalles */}
    <Col md={10}>
        <Card>
            <Card.Header className="bg-success text-white text-center">
                Detalles de las Solicitudes
            </Card.Header>
            <Card.Body>
                {/* <DataTable
                    columns={columnsDetalles}
                    data={vacacionesDetalle}
                    pagination
                    highlightOnHover
                /> */}

                <DataTable
  key={reloadKey + '-detalle'}
  columns={columnsDetalles}
  data={vacacionesDetalle}
  pagination
  highlightOnHover
  conditionalRowStyles={[
    {
      when: (row: DTOVacaciones) => true,
      style: (row: DTOVacaciones) => ({
        backgroundColor: getColorPorEstado(row.estado),
      }),
    },
  ]}
/>

            </Card.Body>
        </Card>
    </Col>
</Row>

                
                </Card.Body>
            </Card>

            {/* Modal */}
            <Modal show={showModal} 
            onHide={cerrarModal}>
                <Modal.Header closeButton>
                    <Modal.Title>{editando ? 'Editar Vacación' : 'Nueva Vacación'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                     <Form.Group>
                    <Form.Label>NumEmpleado</Form.Label>
                    <Form.Control
                        type="text"
                        value={currentVacacion.numEmpleado || ''}
                        readOnly
                        style={{
                            backgroundColor: '#e9ecef', // Color de fondo gris claro
                            color: '#6c757d',          // Texto gris oscuro
                            cursor: 'not-allowed',     // Cursor para indicar que no es editable
                            pointerEvents: 'none',     // Evita interacción del mouse
                        }}
                    />
                    </Form.Group>                                                    
                
                        {/* <Form.Group>
                            <Form.Label>Tipo Solicitud</Form.Label>
                            <Form.Select
                                value={currentVacacion.tipoSolicitud || ''} // Controlado por el estado
                                onChange={(e) =>
                                    setCurrentVacacion((prevState) => ({
                                        ...prevState,
                                        tipoSolicitud: e.target.value, // Actualiza el tipo de solicitud
                                    }))
                                }
                            >
                                <option value="">Seleccione</option>
                                <option value="Rango">Rango de Días</option>
                                <option value="DiasSalteados">Días Salteados</option>
                            </Form.Select>
                        </Form.Group>


                        {currentVacacion.tipoSolicitud === 'Rango' && (
                            <>
                                                        <Form.Group>
                            <Form.Label>Fecha Inicio</Form.Label>
                            <Form.Control
                                type="date"
                                value={Inicio} // Controlado por el estado
                                onChange={handleFechaInicioChange}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Fecha Fin</Form.Label>
                            <Form.Control
                                type="date"
                                value={Fin} // Controlado por el estado
                                onChange={handleFechaFinChange}
                            />
                        </Form.Group>

                            </>
                        )}

                    {currentVacacion.tipoSolicitud === 'DiasSalteados' && (
                        <>
                            <Form.Group>
                                <Form.Label>Días Salteados</Form.Label>
                                
                <Calendar
                    onClickDay={handleDayClick} // Maneja los clics en los días
                    tileClassName={({ date }) =>
                        selectedDays.some((d) => d.getTime() === date.getTime())
                            ? 'selected-day' // Clase CSS para días seleccionados
                            : ''
                    }
                    tileDisabled={({ date }) => {
                        const today = new Date(); // Fecha actual
                        const oneWeekLater = new Date();
                        oneWeekLater.setDate(today.getDate() + 7); // Una semana después del día actual

                        // Deshabilita días antes de una semana desde hoy
                        return date < oneWeekLater;
                    }}
                        />


                            </Form.Group>
                            <Form.Text className="text-muted">
                                Selecciona los días individualmente haciendo clic en ellos.
                            </Form.Text>
                            <ul>
                                {selectedDays.map((day, index) => (
                                    <li key={index}>{day.toLocaleDateString()}</li>
                                ))}
                            </ul>
                        </>
                    )} */}

                                
{/* <Form.Group>
    <Form.Label>Tipo Solicitud</Form.Label>
    <Form.Select value="DiasSalteados" disabled>
        <option value="DiasSalteados">Días Salteados</option>
    </Form.Select>
</Form.Group> */}

<Form.Group>
    <Form.Label>Fechas a disfrutar</Form.Label>
    <Calendar
        onClickDay={handleDayClick} // Maneja los clics en los días
        tileClassName={({ date }) =>
            selectedDays.some((d) => d.getTime() === date.getTime())
                ? 'selected-day' // Clase CSS para días seleccionados
                : ''
        }
        tileDisabled={({ date }) => {
            const today = new Date(); // Fecha actual
            const oneWeekLater = new Date();
            oneWeekLater.setDate(today.getDate() + 7); // Una semana después del día actual

            // Deshabilita días antes de una semana desde hoy
            return date < oneWeekLater;
        }}
    />
</Form.Group>
<Form.Text className="text-muted">
    Selecciona los días individualmente haciendo clic en ellos.
</Form.Text>
<ul>
    {selectedDays.map((day, index) => (
        <li key={index}>{day.toLocaleDateString()}</li>
    ))}
</ul>





                        <Form.Group>
                            <Form.Label>Días a Tomar</Form.Label>
                            <Form.Control
                                type="text"
                                value={currentVacacion.diasTomar || ''}
                                readOnly
                                style={{
                                    backgroundColor: '#e9ecef',
                                    color: '#6c757d',
                                    cursor: 'not-allowed',
                                }}
                            />
                        </Form.Group>

                        

                    <Form.Group>
                        <Form.Label>Días a Pagar</Form.Label>
                        <Form.Control
                            type="number"
                            min="0" // Evita valores negativos desde el navegador
                            value={currentVacacion.diasPagar || ''} // Usa el estado actual
                            onChange={(e) => {
                                const value = Number(e.target.value); // Convierte a número
                                if (!isNaN(value) && value >= 0) { // Acepta solo valores positivos
                                    setCurrentVacacion((prevState) => ({
                                        ...prevState,
                                        diasPagar: value, // Actualiza el estado
                                    }));
                                }
                            }}
                        />
                    </Form.Group>

                            
                           
{(currentVacacion.tipoSolicitud === 'SoloDiasPago' ||
  currentVacacion.tipoSolicitud === 'VacacionesPorDisfrutar') && (
  <Form.Group>
    {/* Campo Día de Pago (jueves) */}
<Form.Group className="mt-3">
  <Form.Label>Día de Pago (jueves)</Form.Label>

  <div style={{ position: 'relative' }}>
    <Form.Control
      type="text"
      readOnly
      value={
        currentVacacion.diaPago
          ? new Date(currentVacacion.diaPago + 'T00:00:00').toLocaleDateString('es-MX', {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric',
            })
          : ''
      }
      placeholder="Seleccionar jueves de pago"
      onClick={() => setShowDiaPagoCalendar((prev) => !prev)}
      style={{ cursor: 'pointer' }}
    />

    {showDiaPagoCalendar && (
      <div
        style={{
          position: 'absolute',
          zIndex: 9999,
          background: 'white',
          boxShadow: '0 4px 10px rgba(0,0,0,0.15)',
          borderRadius: '8px',
          padding: '8px',
          marginTop: '5px',
        }}
      >
        <Calendar
          onClickDay={(date) => {
            // ✅ Solo jueves
            if (date.getDay() === 4) {
              const localDate = new Date(
                date.getFullYear(),
                date.getMonth(),
                date.getDate()
              )
                .toISOString()
                .split('T')[0];

              // ✅ Si ya estaba seleccionado, lo quita
              setCurrentVacacion((prevState) => ({
                ...prevState,
                diaPago: prevState.diaPago === localDate ? null : localDate,
              }));

              setShowDiaPagoCalendar(false);
            } else {
              setHeader('Advertencia');
              setMsg('Solo puedes seleccionar un jueves para el pago.');
              setShowMsg(true);
            }
          }}
          tileDisabled={({ date }) => {
            const today = new Date();
            const oneWeekLater = new Date();
            oneWeekLater.setDate(today.getDate() + 7);

            // ⏳ 2 meses + 1 semana después de hoy
            const twoMonthsAndWeekLater = new Date();
            twoMonthsAndWeekLater.setMonth(today.getMonth() + 2);
            twoMonthsAndWeekLater.setDate(twoMonthsAndWeekLater.getDate() + 7);

            const isThursday = date.getDay() === 4;
            const isInRange = date >= oneWeekLater && date <= twoMonthsAndWeekLater;

            // 🔒 Solo habilitar jueves dentro del rango permitido
            return !isThursday || !isInRange;
          }}
          tileClassName={({ date }) => {
            const localDate = new Date(
              date.getFullYear(),
              date.getMonth(),
              date.getDate()
            )
              .toISOString()
              .split('T')[0];
            return currentVacacion.diaPago === localDate ? 'selected-day' : '';
          }}
        />
      </div>
    )}
  </div>

  <Form.Text className="text-muted">
    Solo puedes seleccionar jueves dentro de los  próximas 2 meses, Si no quieres dias de pago y solo disfrutar los dias se deja en blanco
  </Form.Text>
</Form.Group>

  </Form.Group>
)}



                    

                    <Form.Group controlId="comentarioInput">
  <Form.Label>Observaciones</Form.Label>
  <Form.Control
    as="textarea"
    rows={3}
    value={currentVacacion.observaciones || ''}
    onChange={(e) =>
      setCurrentVacacion((prevState) => ({
        ...prevState,
        observaciones: e.target.value,
      }))
    }
  />
</Form.Group>



                    

                    </Form>
                    </Modal.Body>

        



                 <Modal show={showConfirmModal} onHide={() => setShowConfirmModal(false)}>


                    <Modal.Header closeButton>
                    <Modal.Title>Confirmar Solicitud</Modal.Title>
                     </Modal.Header>
                     <Modal.Body>
                    <p>Por favor, confirma los datos antes de guardar:</p>
                    <ul>
                        <li><strong>Tipo de Solicitud:</strong> {confirmData.tipoSolicitud}</li>
                        {confirmData.tipoSolicitud === 'Rango' && (
                            <>
                                <li><strong>Fecha Inicio:</strong> {confirmData.fechaInicio}</li>
                                <li><strong>Fecha Fin:</strong> {confirmData.fechaFin}</li>
                            </>
                        )}
                        {confirmData.tipoSolicitud === 'VacacionesPorDisfrutar' && (
                            <>
                                <li><strong>Días a Disfrutar:</strong> {confirmData.diasSalteados?.join(', ')}</li>
                            </>
                        )}
                        <li><strong>Días a Tomar:</strong> {confirmData.diasSolicitados}</li>
                        <li><strong>Días a Pagar:</strong> {confirmData.diasPagar}</li>
                         {/* <li><strong>Día de pago:</strong> {confirmData.diaPago}</li> */}
                         <li>
  <strong>Día de pago:</strong>{' '}
  {confirmData.diaPago
    ? (() => {
        try {
          const dateValue =
            typeof confirmData.diaPago === 'string'
              ? new Date(confirmData.diaPago + 'T12:00:00') // ← 🔧 aquí el cambio clave
              : new Date(confirmData.diaPago);

          return isNaN(dateValue.getTime())
            ? '—'
            : dateValue.toLocaleDateString('es-MX', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
              });
        } catch {
          return '—';
        }
      })()
    : '—'}
</li>

                        <li><strong>Observaciones: </strong>{confirmData.observaciones}</li>
                    </ul>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowConfirmModal(false)}>
                        Cancelar
                    </Button>
                    <Button variant="primary" onClick={guardarVacacion}>
                        Confirmar
                    </Button>
                </Modal.Footer>
            </Modal>

            




                
                <Modal.Footer>
                    <Button variant="secondary" onClick={cerrarModal}>
                        Cancelar
                    </Button>
                    {/* <Button variant="primary" onClick={guardarVacacion}>
                        Guardar
                    </Button> */}



                <Button variant="primary" onClick={mostrarConfirmacion}>
                    Guardar
                </Button>


                </Modal.Footer>

                                


            </Modal>



            <Modal show={showInitialModal} onHide={() => setShowInitialModal(false)}>
    <Modal.Header closeButton>
        <Modal.Title>Información del Empleado</Modal.Title>
    </Modal.Header>
    <Modal.Body>
        {empleadoInfo ? (
            <div>
                <p><strong>Empleado:</strong> {empleadoInfo.numEmpleado}</p>
                <p><strong>Nombre:</strong> {empleadoInfo.nombre}</p>
                

<p><strong>Fecha de Ingreso:</strong> 
    {empleadoInfo.fechaIngreso 
        ? new Date(empleadoInfo.fechaIngreso.split(' ')[0]).toLocaleDateString('es-MX', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
        })
        : 'No disponible'}
</p>

                
                <p><strong>Años de Servicio:</strong> {empleadoInfo.anosServicio}</p>
                <p><strong>Días Permitidos:</strong> {empleadoInfo.diasPermitidos}</p>
                <p><strong>Días Tomados:</strong> {empleadoInfo.diasTomados}</p>
                <p><strong>Días Restantes:</strong> {empleadoInfo.diasRestantes}</p>
            </div>
        ) : (
            <p>Cargando información del empleado...</p>
        )}
    </Modal.Body>
    <Modal.Footer>
        <Button variant="primary" onClick={() => setShowInitialModal(false)}>
            Cerrar
        </Button>
    </Modal.Footer>
</Modal>






<Modal show={showDetalleModal} onHide={() => setShowDetalleModal(false)}>
    <Modal.Header closeButton>
        <Modal.Title>
            Estos son los últimos datos de los días que solicitó vacaciones, recuerde que debe insertar datos que no correspondan a estos días.
        </Modal.Title>
    </Modal.Header>
    <Modal.Body>
        <p>
            <strong>{detalleFechas.tipo}:</strong>
        </p>
        <ul>
            {detalleFechas.datos.map((fecha, index) => (
                <li key={index}>{fecha}</li>
            ))}
        </ul>
    </Modal.Body>
    <Modal.Footer>
        <Button variant="secondary" onClick={() => setShowDetalleModal(false)}>
            Cerrar
        </Button>
    </Modal.Footer>
</Modal>


<Modal show={showSpecialModal} onHide={() => setShowSpecialModal(false)}>
    <Modal.Header closeButton>
        <Modal.Title>Solicitud Especial - Solo Días a Pagar</Modal.Title>
    </Modal.Header>
    <Modal.Body>
        <p>
             Esta solicitud es exclusivamente para los casos en los que desea recibir el pago por días de
            vacaciones, sin tomar las vacaciones. Por favor, ingrese el número de días a pagar y confirme.
        </p>
        <Form>
                    
        


        <Form.Group>
                    <Form.Label>NumEmpleado</Form.Label>
                    <Form.Control
                        type="text"
                        value={currentVacacion.numEmpleado || ''}
                        readOnly
                        style={{
                            backgroundColor: '#e9ecef', // Color de fondo gris claro
                            color: '#6c757d',          // Texto gris oscuro
                            cursor: 'not-allowed',     // Cursor para indicar que no es editable
                            pointerEvents: 'none',     // Evita interacción del mouse
                        }}
                    />
                    </Form.Group>   


            <Form.Group>
                <Form.Label>Días a Pagar</Form.Label>
                <Form.Control
                    type="number"
                    min="0"
                    value={specialDaysToPay || ''} // Estado específico para este campo
                    onChange={(e) => {
                        const value = Number(e.target.value);
                        if (!isNaN(value) && value >= 0) {
                            setSpecialDaysToPay(value); // Actualiza el estado
                        }
                    }}
                />
            </Form.Group>

{/* Selección de Día de Pago */}
{/* Campo Día de Pago (jueves) */}
<Form.Group className="mt-3">
  <Form.Label>Día de Pago (jueves)</Form.Label>

  <div style={{ position: 'relative' }}>
    <Form.Control
      type="text"
      readOnly
      value={
        currentVacacion.diaPago
          ? new Date(currentVacacion.diaPago + 'T00:00:00').toLocaleDateString('es-MX', {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric',
            })
          : ''
      }
      placeholder="Seleccionar jueves de pago"
      onClick={() => setShowDiaPagoCalendar((prev) => !prev)}
      style={{ cursor: 'pointer' }}
    />

    {showDiaPagoCalendar && (
      <div
        style={{
          position: 'absolute',
          zIndex: 9999,
          background: 'white',
          boxShadow: '0 4px 10px rgba(0,0,0,0.15)',
          borderRadius: '8px',
          padding: '8px',
          marginTop: '5px',
        }}
      >
        <Calendar
          onClickDay={(date) => {
            // ✅ Solo jueves
            if (date.getDay() === 4) {
              const localDate = new Date(
                date.getFullYear(),
                date.getMonth(),
                date.getDate()
              )
                .toISOString()
                .split('T')[0];

              // ✅ Si ya estaba seleccionado, lo quita
              setCurrentVacacion((prevState) => ({
                ...prevState,
                diaPago: prevState.diaPago === localDate ? null : localDate,
              }));

              setShowDiaPagoCalendar(false);
            } else {
              setHeader('Advertencia');
              setMsg('Solo puedes seleccionar un jueves para el pago. Si solo quires los dias deja en blanco el dia de pago');
              setShowMsg(true);
            }
          }}
          tileDisabled={({ date }) => {
            const today = new Date();
            const oneWeekLater = new Date();
            oneWeekLater.setDate(today.getDate() + 7);

            // ⏳ 2 meses + 1 semana después de hoy
            const twoMonthsAndWeekLater = new Date();
            twoMonthsAndWeekLater.setMonth(today.getMonth() + 2);
            twoMonthsAndWeekLater.setDate(twoMonthsAndWeekLater.getDate() + 7);

            const isThursday = date.getDay() === 4;
            const isInRange = date >= oneWeekLater && date <= twoMonthsAndWeekLater;

            //  Solo habilitar jueves dentro del rango permitido
            return !isThursday || !isInRange;
          }}
          tileClassName={({ date }) => {
            const localDate = new Date(
              date.getFullYear(),
              date.getMonth(),
              date.getDate()
            )
              .toISOString()
              .split('T')[0];
            return currentVacacion.diaPago === localDate ? 'selected-day' : '';
          }}
        />
      </div>
    )}
  </div>

  <Form.Text className="text-muted">
    Solo puedes seleccionar jueves.
  </Form.Text>
</Form.Group>



            

            <Form.Group controlId="observacionesEspecial">
  <Form.Label>Observaciones</Form.Label>
  <Form.Control
    as="textarea"
    rows={3}
    value={specialObservaciones}
    onChange={(e) => setSpecialObservaciones(e.target.value)}
  />
</Form.Group>



                    

                    
            

        </Form>
    </Modal.Body>
    
    <Modal.Footer>
        <Button variant="secondary" onClick={() => setShowSpecialModal(false)}>
            Cancelar
        </Button>
        <Button
            variant="primary"
            onClick={() => {
                handleSpecialRequest();
            }}
        >
            Enviar Solicitud
        </Button>
    </Modal.Footer>
</Modal>



<Modal show={showSpecialConfirmModal} onHide={() => setShowSpecialConfirmModal(false)}>
    <Modal.Header closeButton>
        <Modal.Title>Confirmar Solicitud Especial</Modal.Title>
    </Modal.Header>
    <Modal.Body>
        <p>Por favor, confirma los datos de tu solicitud especial antes de enviarla:</p>
        <ul>
            <li><strong>NumEmpleado:</strong> {specialConfirmData.numEmpleado}</li>
            <li><strong>Días a Pagar:</strong> {specialConfirmData.diasPagar}</li>
            <li>
  <strong>Día de Pago:</strong>{' '}
  {currentVacacion.diaPago
    ? (() => {
        try {
          const dateValue =
            typeof currentVacacion.diaPago === 'string'
              ? new Date(currentVacacion.diaPago + 'T12:00:00') // 🔧 fuerza horario seguro
              : new Date(currentVacacion.diaPago);

          return isNaN(dateValue.getTime())
            ? '—'
            : dateValue.toLocaleDateString('es-MX', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
              });
        } catch {
          return '—';
        }
      })()
    : '—'}
</li>

            <li><strong>Observaciones:</strong>{specialObservaciones}  </li>
        </ul> 
    </Modal.Body>
    <Modal.Footer>
        <Button variant="secondary" onClick={() => setShowSpecialConfirmModal(false)}>
            Cancelar
        </Button>
        <Button variant="primary" onClick={confirmSpecialRequest}>
            Confirmar y Enviar
        </Button>
    </Modal.Footer>
</Modal>



<Modal show={showDetalle} onHide={() => setShowDetalle(false)} centered>
  <Modal.Header closeButton>
    <Modal.Title>Detalle</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <p style={{ whiteSpace: "pre-wrap" }}>{detalleTexto}</p>
  </Modal.Body>
</Modal>


                 <MsgInformativo
                         show={show}
                         msg={msg}
                         header={header}
                         msgColor={msgColor}
                         closeToast={() => {
                           setShowMsg(false)
                         }}
                       />               
           
        </div>

        
    );


    
};

export default VacacionesComponent;



